import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  uploadPanel: {
    border: `1px dashed ${theme.palette.grey[400]}`,
    borderRadius: 4,
    backgroundColor: theme.palette.grey[50],
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  uploadContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 14,
  },
  uploadTextGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  uploadTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  uploadDescription: {
    color: theme.palette.text.secondary,
    lineHeight: 1.35,
  },
  noFileUploaded: {
    lineHeight: 1.35,
    padding: 6,
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  uploadButton: {
    whiteSpace: 'nowrap',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    color: theme.palette.text.primary,
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      backgroundColor: theme.palette.action.hover,
    },
  },
  uploadFileList: {
    display: 'flex',
    gap: 6,
  },
  fileItem: {
    backgroundColor: "#FFF"
  }
}));
